export const PROJECT_COLLECTION = {
  'ANSWERS': 'Answers',
  'PERFORMANCES': 'Performance'
};
